<template>
  <th :class="getClass">
    <div class="hvh-flex align-center" :class="{ clickable: sortFnc }" @mousemove="isHovering = true" @mouseenter="isHovering = true" @mouseleave="isHovering = false">
      <span @click="changeSort"><slot /></span>
      <span class="caret-wrapper" @click="changeSort" v-if="sortFnc">
        <span class="v-icon notranslate v-data-table-header__icon theme--light" style="font-size: 18px; height: 18px; width: 18px">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg" style="font-size: 18px; height: 18px; width: 18px">
            <path d="M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z" :fill="fillColor"></path>
          </svg>
        </span>
      </span>
    </div>
  </th>
</template>

<script>
import { propToBool, propToFnc } from '../../../libraries/common';
import { getAllParents } from '../../../libraries/vue';

const sortDirections = [null, 'asc', 'desc'];

export default {
  name: 'hvh-th',
  props: ['prop', 'sort', 'export', 'excelTitle', 'searchable'],
  data() {
    return {
      parentTable: null,
      isHovering: false,
    };
  },
  methods: {
    changeSort() {
      if (this.sortFnc) {
        var nextSortInd = Math.max(sortDirections.indexOf(this.sortDirection), 0) + 1;
        if (nextSortInd >= sortDirections.length) nextSortInd = 0;

        var sortDirection = sortDirections[nextSortInd];
        this.parentTable.emitState({
          sortBy: sortDirection ? this.indexInTable : null,
          sortDirection,
          sortByProp: sortDirection ? (this.sort || this.prop) : null,
          page: 1,
        });
      }
    },
    propToBool,
  },
  computed: {
    sortDirection() {
      return this.parentTable && (this.parentTable.value || {}).sortBy === this.indexInTable && this.parentTable.value.sortDirection || null;
    },
    indexInTable() {
      return this.parentTable && this.parentTable.getHeadChildren().indexOf(this);
    },
    getClass() {
      if (!this.sortFnc) return '';
      return `sorting${this.sortDirection ? ` ${this.sortDirection}` : ''}`;
    },
    sortFnc() {
      if (!propToBool(this.sort)) return null;
      return propToFnc(this.sort || this.prop || (() => null));
    },
    exportFnc() {
      if (!propToBool(this.export)) return null;
      var exportBy = this.export || this.prop;
      if (exportBy) {
        return propToFnc(exportBy);
      }
      return null;
    },
    fillColor() {
      if (this.sortDirection)
        return 'black';
      return this.isHovering ? 'rgba(0,0,0,.38)' : 'transparent';
    },
  },
  mounted() {
    this.parentTable = getAllParents(this.$parent).first(f => f.isDataTable && f._data.$tds);
    if (this.parentTable) {
      this.parentTable._data.$tds.push(this);
    }
  },
  beforeDestroy() {
    if (this.parentTable) {
      this.parentTable._data.$tds.remove(this);
    }
  }
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}

.sorting {
  .caret-wrapper {
    transform: rotate(0);
    transition: transform 250ms ease;
  }
  &.desc {
    .caret-wrapper {
      transform: rotate(-180deg);
    }
  }
}
</style>